export const header = {
    logo: {
        brandName: 'Fronteira Sul Drones',
        tagline: 'Drone Solutions',
        ariaLabel: 'Go to top of page',
    },
    navigation: {
        home: 'Home',
        drones: 'Drones',
        newDrones: 'New Drones',
        usedDrones: 'Used Drones',
        buffalo: 'Buffalo Line',
        powerCitros: 'Power Citros',
        parts: 'Parts',
        services: 'Services',
        about: 'About',
        contact: 'Contact',
    },
    mobileMenu: {
        toggleAriaLabel: 'Toggle menu',
        closeAriaLabel: 'Close menu',
    },
    actions: {
        search: 'Search',
        cart: 'Cart',
        account: 'Account',
        toggleTheme: 'Toggle theme',
        back: 'Back',
    },
    catalog: {
        title: 'Catalog',
    },
};
//# sourceMappingURL=header.js.map